(function($){

    $.fn.repeater = function(options)
    {
        var defaults = {
            add_button: 'a[data-add]',
            remove_button: 'a[data-remove]',
            remove_input: 'input[role="delete"]',
            primary_input: 'input[role="primary"]',
            class: {
                error: '__error'
            }
        }

        var settings = $.extend(defaults, options);
        var target = $(this);
        var i = 0;

        if (settings.add_button) {
            var add_buttons = $(settings.add_button);
        }
        if (settings.data) {
            var rows = $.parseJSON(settings.data);
        }
        if (settings.errors) {
            var errors = $.parseJSON(settings.errors);
        }

        function resolve(path, obj)
        {
            return path.split('.').reduce(function(prev, curr) {
                return prev ? prev[curr] : null
            }, obj || self)
        }

        function addRow(data, template)
        {
            if (template) {
                var layout = $(template);
            } else {
                var layout = $(settings.template);
            }

            if (layout.length == 0) {
                var layout = $(settings.template);
            }

            var row = function()
            {
                var source = layout.html();
                var template = Handlebars.compile(source);
                var context = {
                    i: i,
                    row: data
                };
                var html = template(context);
                return $(html);
            }();

            if (data) {
                var inputs = row.find('input,textarea,select');

                inputs.each(function(e)
                {
                    var input = $(this);
                    var name = input.attr('name');
                    var key = input.attr('data-name');

                    if (name) {
                        name = name.replace('[]', '[' + i + ']');
                        name = name.replace('][', '.');
                        name = name.replace('][', '.'); //repeat
                        name = name.replace('][', '.'); //repeat
                        name = name.replace('][', '.'); //repeat
                        name = name.replace('[', '.');
                        name = name.replace(']', '');
                    }

                    if (key) {
                        var val = resolve(key, data);

                        if (input.is('select')) {
                            input.find('option[value="' + val + '"]').attr('selected', 'selected');
                        } else if (input.is('[type="checkbox"]')) {
                            input.filter('[value="' + val + '"]').attr('checked', 'checked');
                        } else {
                            input.val(val);
                        }
                    }

                    if (errors !== undefined && name in errors) {
                        input.addClass(settings.class.error);
                    }
                });
            }

            if (settings.min && i < settings.min) {
                if (settings.remove_input) {
                    row.find(settings.remove_input).remove();
                }
                if (settings.remove_button) {
                    row.find(settings.remove_button).remove();
                }
            }

            i++;
            target.append(row);
        }

        $(document).on('click', settings.remove_button, function(e)
        {
            e.preventDefault();
            var j = $(this).attr('data-remove');
            var row = target.find('div[data-row="' + j + '"]');
            var primary = row.find(settings.primary_input);

            if (primary) {
                if (primary.val()) {
                    row.find(settings.remove_input).val(1);
                    row.hide();
                    return;
                }
            }

            row.remove();
        });

        add_buttons.click(function(e)
        {
            e.preventDefault();
            var button = $(this);
            var template = button.attr('data-add');
            addRow(null, template);
        });

        $.each(rows, function(key, row){
            addRow(row);
        });

        if (settings.min) {
            while (i < settings.min) {
                addRow();
            }
        }

        return {
            addRow: function(row, template) {
                addRow(row, template);
            }
        }

    }

}(jQuery));



// WEBPACK FOOTER //
// ./packages/SMP/js/repeater.js